import React from "react";
import { Typography, Stack } from "@mui/material";
import { timeConfig } from "./helper";

const HubTimePickerRender = ({ time, fields }) => {
  return (
    <Stack
      direction="row"
      gap="7px"
      sx={{
        "& .MuiTypography-root": {
          fontSize: 11,
        },
      }}
    >
      {fields.map((field) => (
        <Typography key={field}>
          {Math.round((time[field] ?? 0) * 100) / 100 +
            timeConfig[field].shortLabel}
        </Typography>
      ))}
    </Stack>
  );
};

export default HubTimePickerRender;
